import { allArticles } from '@/mocks/articles';

export default function ArticlePreview() {
  return (
    <section id="blog" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/70 rounded-full text-xs font-medium text-primary-700 mb-4">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-article-line text-xs"></i>
            </div>
            Blog SEO
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Artykuły i Poradniki Kakobuy Spreadsheet
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Poznaj szczegółowe przewodniki, rankingi i analizy dotyczące Kakobuy Spreadsheet, które pomogą Ci robić lepsze zakupy online
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {allArticles.map((article) => (
            <a
              key={article.slug}
              href={`/artykul/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200 hover:-translate-y-1 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime} czytania</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/50">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                    Czytaj więcej
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-[10px]"></i>
                    </div>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Kakobuy Spreadsheet
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}